
export const OSM_URL = process.env.REACT_APP_OSM_URL;